import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import PropertyGrid from './components/PropertyGrid';
import Features from './components/Features';
import About from './components/About';
import Testimonial from './components/Testimonial';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-12">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`ri-home-4-line text-2xl ${scrolled ? 'text-slate-900' : 'text-white'}`}></i>
              </div>
              <span className={`text-xl font-serif ${scrolled ? 'text-slate-900' : 'text-white'}`}>
                プライム不動産
              </span>
            </Link>
            <div className="flex items-center gap-10">
              <Link to="/" className={`text-sm ${scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white/90 hover:text-white'} transition-colors`}>
                物件情報
              </Link>
              <Link to="/" className={`text-sm ${scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white/90 hover:text-white'} transition-colors`}>
                会社概要
              </Link>
              <Link to="/" className={`text-sm ${scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white/90 hover:text-white'} transition-colors`}>
                お問い合わせ
              </Link>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/" className={`text-sm ${scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white/90 hover:text-white'} transition-colors`}>
              会員ログイン
            </Link>
            <Link to="/" className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
              scrolled 
                ? 'bg-slate-900 text-white hover:bg-slate-800' 
                : 'bg-white text-slate-900 hover:bg-slate-100'
            }`}>
              無料相談予約
            </Link>
          </div>
        </div>
      </nav>

      <Hero />
      <PropertyGrid />
      <Features />
      <About />
      <Testimonial />
      <CTA />
      <Footer />
    </div>
  );
}
